import React, { useContext, useEffect, useState } from "react";
import ajaxAccounting from "../../util/remote/ajaxAccounting";
import Select from "react-select";
import ajaxProject from "../../util/remote/ajaxProject";
import toast, { Toaster } from "react-hot-toast";
import AuthContext from "../../Context/AuthContext";
import ajaxUser from "../../util/remote/ajaxUser";

function RecieptsCreate(props) {
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState("");
  const [projectID, setProjectID] = useState("");
  const [LedgerID_credited, setLedgerID_credited] = useState("");
  const [LedgerID_debited, setLedgerID_debited] = useState("");
  const [description, setDescription] = useState("");
  const [cost_item, setCost_item] = useState("");
  const [date, setDate] = useState("");
  const [reciever, setReciever] = useState("");
  const [employee, setEmployee] = useState("");
  const [trans_type, setTrans_type] = useState("receipt");
  const [invoice_reff, setInvoice_reff] = useState([]); // selected invoices
  const [Supplier_ivoice_reff, setSupplier_ivoice_reff] = useState("");
  const [voucher_no, setVoucher_no] = useState("");
  const [totalInvoiceAmount, setTotalInvoiceAmount] = useState(0); // total of selected invoices

  const { userId } = useContext(AuthContext);

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setDate(today);
  }, []);

  // Form submission
  const handleAdd = async (e) => {
    e.preventDefault();

    if (
      LedgerID_credited.trim() === "" ||
      LedgerID_debited.trim() === "" ||
      amount.trim() === "" ||
      date.trim() === "" ||
      LedgerID_credited === LedgerID_debited
    ) {
      toast.error(
        "Please complete all fields and make sure the selected ledger are not the same"
      );
      return;
    }

    // Only check amount if invoices are selected
    if (invoice_reff.length > 0 && parseFloat(amount) > totalInvoiceAmount) {
      toast.error("Amount exceeds the total of selected invoices");
      return;
    }

    setLoading(true);

    const invoiceRefs = invoice_reff.map((inv) => inv.FolioReff);
    const data = {
      folioID: "",
      amount: amount,
      projectID: projectID,
      LedgerID_debited: LedgerID_debited,
      LedgerID_credited: LedgerID_credited,
      cost_item: cost_item,
      date: date,
      reciever: reciever,
      employee: employee,
      created_by: userId,
      trans_type: trans_type,
      description: description,
      Supplier_ivoice_reffs: Supplier_ivoice_reff,
      voucher_no: voucher_no,
      invoice_reff: invoiceRefs,
    };

    const server_response = await ajaxAccounting.CreatePaymentVoucher(data);
    setLoading(false);

    if (server_response.status === "OK") {
      toast.success(server_response.message);
      getInvoices();
      props.function();
      resetForm();
    } else {
      toast.error(server_response.message);
    }
  };

  const resetForm = () => {
    setProjectID("");
    setAmount("");
    setCost_item("");
    setLedgerID_credited("");
    setLedgerID_debited("");
    setReciever("");
    setDescription("");
    setInvoice_reff([]);
    setTotalInvoiceAmount(0);
  };

  // Fetch employees
  const [employees, setEmployees] = useState([]);
  const getEmployees = async () => {
    const server_response = await ajaxUser.getUsersMinimal_data();
    if (server_response.status === "OK") {
      setEmployees(server_response.details);
    } else {
      setEmployees([]);
    }
  };

  // Fetch debited ledgers
  const [Debitledgers, setDebitledgers] = useState([]);
  const getDebitlegders = async () => {
    const server_response =
      await ajaxAccounting.getALlLedgersMinData_cash_or_bank();
    if (server_response.status === "OK") {
      setDebitledgers(server_response.details);
    } else {
      setDebitledgers([]);
    }
  };

  // Fetch credited ledgers
  const [creditLedger, setCreditLedger] = useState([]);
  const getCreditlegders = async () => {
    const server_response =
      await ajaxAccounting.getALlLedgersMinData_non_cash_or_bank();
    if (server_response.status === "OK") {
      setCreditLedger(server_response.details);
    } else {
      setCreditLedger([]);
    }
  };

  useEffect(() => {
    getDebitlegders();
    getCreditlegders();
    getEmployees();
    getInvoices();
    getProjects();
    getCost_Allocations();
  }, []);

  // Fetch projects
  const [projects, setProjects] = useState([]);
  const getProjects = async () => {
    const server_response = await ajaxProject.getProjectsMinnimalDataCliented();
    if (server_response.status === "OK") {
      setProjects(server_response.details);
    } else {
      setProjects([]);
    }
  };

  // Fetch invoices
  const [invoices, setInvoices] = useState([]);
  const [filteredInvoices, setFilteredInvoices] = useState([]);
  const getInvoices = async () => {
    const server_response = await ajaxAccounting.getInvoiceReferences();
    if (server_response.status === "OK") {
      setInvoices(server_response.details);
      setFilteredInvoices(server_response.details);
    } else {
      setInvoices([]);
      setFilteredInvoices([]);
    }
  };

  // Fetch cost allocations
  const [cost_allocations, setCost_allocations] = useState([]);
  const getCost_Allocations = async () => {
    const server_response =
      await ajaxAccounting.getAllcostAllocations_min_data();
    if (server_response.status === "OK") {
      setCost_allocations(server_response.details);
    } else {
      setCost_allocations([]);
    }
  };

  // Ledger change filters invoices
  const handleLedgerChange = (e) => {
    if (e) {
      setLedgerID_credited(e.id);
      const selected = e.id;
      const filtered = invoices.filter(
        (invoice) => invoice.ledger_debited === selected
      );
      setFilteredInvoices(filtered);
    }
  };

  // Invoice selection
  const handleInvoiceChange = (selectedInvoices) => {
    const selectAllOption = selectedInvoices?.find(
      (item) => item.value === "*"
    );

    if (selectAllOption) {
      const allInvoices = filteredInvoices;
      setInvoice_reff(allInvoices);
      const totalAmount = allInvoices.reduce(
        (sum, invoice) => sum + parseFloat(invoice.balance || 0),
        0
      );
      setTotalInvoiceAmount(totalAmount);
    } else {
      setInvoice_reff(selectedInvoices || []);
      const totalAmount = (selectedInvoices || []).reduce(
        (sum, invoice) => sum + parseFloat(invoice.balance || 0),
        0
      );
      setTotalInvoiceAmount(totalAmount);
    }
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "Ugx",
    }).format(value);
  };

  return (
    <div>
      <Toaster />
      <div className="card custom-card" style={{ borderRadius: "10px" }}>
        <div className="card-body">
          <h6 className="card-title mb-4">Add Receipts</h6>
          <form onSubmit={handleAdd} method="post">
            <div className="row">
              <input
                type="hidden"
                value={trans_type}
                className="form-control"
              />
              {/* Project */}
              <div className="mb-4 col-md-3">
                <label>select project</label>
                <Select
                  onChange={(e) => setProjectID(e.id)}
                  getOptionLabel={(option) => option.project_name}
                  getOptionValue={(option) => option.id}
                  isSearchable
                  options={projects}
                  value={
                    projectID
                      ? projects.find((value) => value.id === projectID)
                      : ""
                  }
                />
              </div>

              {/* Debit Ledger */}
              <div className="mb-4 col-md-4">
                <label>
                  Select Account To Debit{" "}
                  <span style={{ color: "red" }}>*</span>
                </label>
                <Select
                  onChange={(e) => setLedgerID_debited(e.id)}
                  getOptionLabel={(option) => option.name}
                  getOptionValue={(option) => option.id}
                  isSearchable
                  options={Debitledgers}
                  value={
                    LedgerID_debited
                      ? Debitledgers.find(
                          (value) => value.id === LedgerID_debited
                        )
                      : ""
                  }
                />
              </div>

              {/* Credit Ledger */}
              <div className="mb-4 col-md-4">
                <label>
                  Select Account To Credit{" "}
                  <span style={{ color: "red" }}>*</span>
                </label>
                <Select
                  onChange={handleLedgerChange}
                  getOptionLabel={(option) => option.name}
                  getOptionValue={(option) => option.id}
                  isSearchable
                  options={creditLedger}
                  value={
                    LedgerID_credited
                      ? creditLedger.find(
                          (value) => value.id === LedgerID_credited
                        )
                      : ""
                  }
                />
              </div>

              {/* Cost Allocation */}
              <div className="mb-4 col-md-4">
                <label>cost allocation center</label>
                <Select
                  onChange={(e) => setCost_item(e.id)}
                  getOptionLabel={(option) => option.item}
                  getOptionValue={(option) => option.id}
                  isSearchable
                  options={cost_allocations}
                  value={
                    cost_item
                      ? cost_allocations.find((value) => value.id === cost_item)
                      : ""
                  }
                />
              </div>

              {/* Amount */}
              <div className="mb-4 col-md-4">
                <label>
                  Amount{" "}
                  {invoice_reff.length > 0 && (
                    <span style={{ color: "red" }}>
                      must be ≤ {formatCurrency(totalInvoiceAmount)}
                    </span>
                  )}
                </label>
                <input
                  onChange={(e) => setAmount(e.target.value)}
                  type="number"
                  value={amount}
                  className="form-control"
                  name="Amount"
                  required
                  min="0"
                />
              </div>

              {/* Invoice Multi-Select */}
              <div className="mb-4 col-md-4">
                <label>Invoice</label>
                <Select
                  options={
                    LedgerID_credited
                      ? [
                          { label: "Select All", value: "*" },
                          ...filteredInvoices,
                        ]
                      : []
                  }
                  onChange={handleInvoiceChange}
                  isMulti
                  getOptionLabel={(option) => option.label || option.reff}
                  getOptionValue={(option) => option.value || option.FolioReff}
                  value={invoice_reff}
                />
              </div>

              {/* Reciever */}
              <div className="mb-4 col-md-4">
                <label>
                  Reciever <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  value={reciever}
                  onChange={(e) => setReciever(e.target.value)}
                  className="form-control"
                />
              </div>

              {/* Employee */}
              <div className="mb-4 col-md-4">
                <label>Employee</label>
                <Select
                  onChange={(e) => setEmployee(e.id)}
                  getOptionLabel={(option) => option.User_name}
                  getOptionValue={(option) => option.id}
                  isSearchable
                  options={employees}
                  value={
                    employee
                      ? employees.find((value) => value.id === employee)
                      : ""
                  }
                />
              </div>

              {/* Date */}
              <div className="mb-4 col-md-4">
                <label>
                  Date <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="date"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  className="form-control"
                />
              </div>

              {/* Description */}
              <div className="mb-4 col-md-12">
                <label>
                  Description <span style={{ color: "red" }}>*</span>
                </label>
                <textarea
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  className="form-control"
                ></textarea>
              </div>
            </div>

            <button type="submit" className="btn btn-primary">
              {loading ? "Processing..." : "Create Receipt"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default RecieptsCreate;
